import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { PostCSVModal } from "../component/PostCSVModal";
import { GetXLSXPaymentModal } from "../component/GetXLSXPaymentModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import { getPayments, getPayment } from "../api/payment";
import {
  putPaymentCheckRecordFlg,
  putPaymentCheckRecordFlgs,
} from "../api/paymentCheckFlg";
import {
  getSerchProducts,
  getSerchHighRankCompanys,
  getSerchSaleCompanys,
} from "../api/serch";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import { postHighRankPaymentConfirmExcelRecords } from "../api/paymentConfirmExcelRecord";

// InterFace
import { paymentTableColumn } from "../config/payment";
import { dataDifine } from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

// 営業アカウント取込
const postCSVColumnPayment = [
  "申込番号",
  "顧客電話番号",
  "商材名",
  "サービス名",
  "上位店振込日",
  "上位店支払額",
  "支払方法",
];

function Payment() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント"],
      name: "上位店明細CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント"],
      name: "明細作成・確定",
    },
    {
      auth: ["パートナー"],
      name: "明細出力",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addCSVDataName === "上位店明細CSV取込") {
      setPostCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "明細作成・確定") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
        payment_year: serchString.payment_year,
        payment_month: serchString.payment_month,
      });
    }
  }, [getXLSXDataName]);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allCheckFlg, setAllCheckFlg] = useState<boolean>(false);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string;
  } | null>(null);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(true);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  const serchColumn: { [key: string]: string } =
    paymentTableColumn.dataColumn.reduce((column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getPayments({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.payments);
      const countPayments = Number(fetchData.countPayments);
      setTotalCount(countPayments);
      setMaxPageNumber(Math.ceil(countPayments / displayNumber));
      setAllCheckFlg(fetchData.allCheckFlg);
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const contract_number = key.contract_number;
    const product_name = key.product_name;
    const service_name = key.service_name;
    const trading_type = key.trading_type;
    const unique_payment_name = key.unique_payment_name;
    const pm_payment_method = key.pm_payment_method;
    const ctt_payment_method = key.ctt_payment_method;
    const customer_phone_number = key.customer_phone_number;
    const payment_company_status = key.payment_company_status;
    const high_rank_company_name = key.high_rank_company_name;
    const payment_sale_company_name = key.payment_sale_company_name;

    setIsLoading(true);
    const dataDetail = await getPayment({
      ...serchString,
      contract_number,
      product_name,
      service_name,
      trading_type,
      unique_payment_name,
      pm_payment_method,
      ctt_payment_method,
      customer_phone_number,
      payment_company_status,
      high_rank_company_name,
      payment_sale_company_name,
    });
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // CSV取込
  const [postCSVStatus, setPostCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postCSVStatus]);
  async function postPaymentsCSV(postDatas: File) {
    setPostCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "payment";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.inputCSVPaymentWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVStatus({
          status: "loading",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostCSVStatus({
          status: "result",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 明細Excel取得
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status:
      | "none"
      | "open"
      | "getting"
      | "confirm"
      | "error_confirm"
      | "send_mail"
      | "error_send_mail"
      | "result"
      | "loading"
      | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
    payment_day: string;
    saleCompanyUniquePaymentIDs: string[];
    saleCompanyUniquePayments: {
      id: string;
      sale_company_unique_payment_name: string;
      sale_company_unique_payment_value: string;
    }[];
    destination_key: string;
    confirm_destination_key: string;
    payment_target: "partner_payment" | "high_rank_payment";
  }>({
    status: "none",
    message: "",
    sale_company_id: null,
    sale_company_name: "",
    payment_year: thisYear.toString(),
    payment_month: thisMonth.toString(),
    payment_day: "28",
    saleCompanyUniquePaymentIDs: [],
    saleCompanyUniquePayments: [],
    destination_key: "",
    confirm_destination_key: "",
    payment_target: "partner_payment",
  });
  useEffect(() => {
    if (getXLSXStatus.status === "loading") {
      setIsLoading(true);
    } else if (getXLSXStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [getXLSXStatus]);
  const [saleCompanyUniquePayments, setSaleCompanyUniquePayments] = useState<
    {
      id: string;
      sale_company_unique_payment_name: string;
      sale_company_unique_payment_value: string;
    }[]
  >([]);

  async function getPaymentsXLSX() {
    setGetXLSXStatus({
      ...getXLSXStatus,
      status: "loading",
    });
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "get_xlsx",
      sale_company_id: getXLSXStatus.sale_company_id,
      sale_company_name: getXLSXStatus.sale_company_name,
      payment_year: getXLSXStatus.payment_year,
      payment_month: getXLSXStatus.payment_month,
      payment_day: getXLSXStatus.payment_day,
      saleCompanyUniquePayments: getXLSXStatus.saleCompanyUniquePayments,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXPaymentsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute(
          "download",
          "【" +
            getXLSXStatus.payment_year +
            "年" +
            getXLSXStatus.payment_month +
            "月度明細】" +
            getXLSXStatus.sale_company_name +
            " 御中.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        const destination_key = decodedData.destination_key;
        const confirm_destination_key = decodedData.confirm_destination_key;
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "confirm",
          destination_key,
          confirm_destination_key,
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }
  async function confirmHighRankPaymentRecords() {
    setGetXLSXStatus({
      ...getXLSXStatus,
      status: "loading",
    });
    const responce = await postHighRankPaymentConfirmExcelRecords({
      payment_year: getXLSXStatus.payment_year,
      payment_month: getXLSXStatus.payment_month,
    });
    if (responce == "success") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        message: "上位店の支払のみのレコードを確定しました。",
        status: "result",
      });
    } else {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "error_confirm",
      });
    }
  }

  // テーブルチェックボックスのON・OFF
  async function switchTableCheckBox(dataKey: { [key: string]: string }) {
    setIsLoading(true);
    if (dataKey.key == "payment_check_record_flg") {
      const responce = await putPaymentCheckRecordFlg({
        ...dataKey,
        payment_year: serchString["payment_year"],
        payment_month: serchString["payment_month"],
      });
      if (responce == "success") {
        await getTableData(true);
      }
    }
    setIsLoading(false);
  }

  // テーブル内の全データのチェックボックスのON・OFF
  async function switchAllTableCheckBox() {
    setIsLoading(true);
    let checkList: { [key: string]: string }[] = [];
    fetchData.map((data) => {
      if (allCheckFlg) {
        if (
          data.payment_check_record_flg === "1" &&
          data.payment_check_record_flg_disable === "1"
        ) {
          checkList.push({
            contract_number: data.contract_number as string,
            product_name: data.product_name as string,
            service_name: data.service_name as string,
            trading_type: data.trading_type as string,
            unique_payment_name: data.unique_payment_name as string,
            pm_payment_method: data.pm_payment_method as string,
            ctt_payment_method: data.ctt_payment_method as string,
            customer_phone_number: data.customer_phone_number as string,
            payment_company_status: data.payment_company_status as string,
            high_rank_company_name: data.high_rank_company_name as string,
            payment_sale_company_name: data.payment_sale_company_name as string,
            payment_year: serchString["payment_year"],
            payment_month: serchString["payment_month"],
          });
        }
      } else {
        if (
          data.payment_check_record_flg !== "1" &&
          data.payment_check_record_flg_disable === "1"
        ) {
          checkList.push({
            contract_number: data.contract_number as string,
            product_name: data.product_name as string,
            service_name: data.service_name as string,
            trading_type: data.trading_type as string,
            unique_payment_name: data.unique_payment_name as string,
            pm_payment_method: data.pm_payment_method as string,
            ctt_payment_method: data.ctt_payment_method as string,
            customer_phone_number: data.customer_phone_number as string,
            payment_company_status: data.payment_company_status as string,
            high_rank_company_name: data.high_rank_company_name as string,
            payment_sale_company_name: data.payment_sale_company_name as string,
            payment_year: serchString["payment_year"],
            payment_month: serchString["payment_month"],
          });
        }
      }
    });
    const responce = await putPaymentCheckRecordFlgs(checkList);
    if (responce == "success") {
      await getTableData(true);
    }
    setIsLoading(false);
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  // 上位店一覧取得
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[]
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        }
      );
      setProductNameList(productNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }
  useEffect(() => {
    getHighRankCompanyList();
    getSaleCompanysList();
    getProductList();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }} data-testid="payment-admin-page">
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={paymentTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubTableName={() => {}}
              getSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubTableDetail={() => {}}
              setGetSubTableAdd={() => {}}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={
                paymentTableColumn.title +
                "(" +
                serchString["payment_year"] +
                "/" +
                serchString["payment_month"] +
                ")"
              }
              switchTableCheckBox={switchTableCheckBox}
              allCheckFlg={allCheckFlg}
              switchAllTableCheckBox={switchAllTableCheckBox}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={() => {}}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={paymentTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Payment"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={dataDetail !== null}
        swCloseModal={() => setDataDetail(null)}
        detailTitle={paymentTableColumn.detailTitle}
        editAuth={paymentTableColumn.editAuth}
        dataColumn={paymentTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={() => {}}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <PostCSVModal
        onModal={
          postCSVStatus.status !== "none" && postCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVStatus}
        setPostCSVStatus={setPostCSVStatus}
        postCSVFunc={postPaymentsCSV}
        postCSVTitle={paymentTableColumn.postCSVTitle}
        postCSVColumn={postCSVColumnPayment}
        postCSVColumnResult={postCSVColumnPayment}
        postCSVPath="payment"
        productList={[]}
        categoryList={[]}
      />
      <GetXLSXPaymentModal
        onModal={
          getXLSXStatus.status !== "none" && getXLSXStatus.status !== "loading"
        }
        swCloseModal={() => {
          setGetXLSXStatus({
            status: "none",
            message: "",
            sale_company_id: null,
            sale_company_name: "",
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
            payment_day: "28",
            saleCompanyUniquePaymentIDs: [],
            saleCompanyUniquePayments: [],
            destination_key: "",
            confirm_destination_key: "",
            payment_target: "partner_payment",
          });
          setSaleCompanyUniquePayments([]);
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getPaymentsXLSX}
        saleCompanyUniquePayments={saleCompanyUniquePayments}
        setSaleCompanyUniquePayments={setSaleCompanyUniquePayments}
        firstYear={firstYear}
        thisYear={thisYear}
        thisMonth={thisMonth}
        companyList={companyList}
        confirmHighRankPaymentRecords={confirmHighRankPaymentRecords}
      />
    </Box>
  );
}
export default Payment;
